<div class="homeCardHeader">
    <i class="icon" [ngClass]="iconClass"></i><span> {{ description }} </span>
    <ng-content select="[deletable]"></ng-content>
    <!-- <a style="font-size: 18px;color: rgb(116, 113, 113);" class="icon icon-trash" (click)="onClick_deleteFavoriteItem(item)"></a> -->
    &nbsp;&nbsp;
    <ng-content select="[pendingCharge]"></ng-content>
</div>
<ng-content select="[alias]"></ng-content>